var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { LocalizableString } from "survey-core";
import { ReactElementFactory } from "./element-factory";
var SurveyLocStringViewer = /** @class */ (function (_super) {
    __extends(SurveyLocStringViewer, _super);
    function SurveyLocStringViewer(props) {
        var _this = _super.call(this, props) || this;
        _this.onChangedHandler = function (sender, options) {
            if (_this.isRendering)
                return;
            _this.setState({ changed: !!_this.state && _this.state.changed ? _this.state.changed + 1 : 1 });
        };
        _this.rootRef = React.createRef();
        return _this;
    }
    Object.defineProperty(SurveyLocStringViewer.prototype, "locStr", {
        get: function () {
            return this.props.locStr;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLocStringViewer.prototype, "style", {
        get: function () {
            return this.props.style;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLocStringViewer.prototype, "textClass", {
        get: function () {
            return this.props.textClass;
        },
        enumerable: false,
        configurable: true
    });
    SurveyLocStringViewer.prototype.componentDidMount = function () {
        this.reactOnStrChanged();
    };
    SurveyLocStringViewer.prototype.componentWillUnmount = function () {
        if (!this.locStr)
            return;
        this.locStr.onStringChanged.remove(this.onChangedHandler);
    };
    SurveyLocStringViewer.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (!!prevProps.locStr) {
            prevProps.locStr.onStringChanged.remove(this.onChangedHandler);
        }
        this.reactOnStrChanged();
    };
    SurveyLocStringViewer.prototype.reactOnStrChanged = function () {
        if (!this.locStr)
            return;
        this.locStr.onStringChanged.add(this.onChangedHandler);
    };
    SurveyLocStringViewer.prototype.render = function () {
        if (!this.locStr)
            return null;
        this.isRendering = true;
        var strEl = this.renderString();
        this.isRendering = false;
        return strEl;
    };
    SurveyLocStringViewer.prototype.renderString = function () {
        var className = this.locStr.getStringViewerClassName(this.textClass);
        if (this.locStr.hasHtml) {
            var htmlValue = { __html: this.locStr.renderedHtml };
            return React.createElement("span", { ref: this.rootRef, className: className, style: this.style, dangerouslySetInnerHTML: htmlValue });
        }
        return React.createElement("span", { ref: this.rootRef, className: className, style: this.style }, this.locStr.renderedHtml);
    };
    return SurveyLocStringViewer;
}(React.Component));
export { SurveyLocStringViewer };
ReactElementFactory.Instance.registerElement(LocalizableString.defaultRenderer, function (props) {
    return React.createElement(SurveyLocStringViewer, props);
});
